import PropTypes from 'prop-types';
// next
import NextLink from 'next/link';
import { useRouter } from 'next/router';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Stack, Divider, Button } from '@mui/material';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_SETTINGS } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const RootStyle = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_8],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

const AvatarStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { user, application } = useAuth();
  const router = useRouter();

  // 종료날짜 역순으로 정렬함. 종료날짜가 없는 경우는 가장 위로 올라오도록 함.
  const sortedCareer = application?.careers?.sort((a, b) => {
    if (a.end_date === null ) return -1;
    if (b.end_date === null ) return 1;
    if (a.end_date > b.end_date) return -1;
    if (a.end_date < b.end_date) return 1;
    return 0;
  });

  const goSetting = (e) => {
    e.preventDefault();
    router.push({pathname: PATH_SETTINGS.root});
  };

  return (
    <NextLink href={PATH_DASHBOARD.crew} passHref>
      <Link underline="none" color="inherit">
        <RootStyle spacing={2}>
          {/* avatar & nickname */}
          <AvatarStyle
            sx={{
              ...(isCollapse && {
                bgcolor: 'transparent',
              }),
            }}
          >
            <MyAvatar />

            <Box
              sx={{
                ml: 2,
                overflow: 'hidden',
                transition: (theme) =>
                  theme.transitions.create('width', {
                    duration: theme.transitions.duration.shorter,
                  }),
                ...(isCollapse && {
                  ml: 0,
                  width: 0,
                }),
              }}
            >
              <Typography variant="subtitle1" sx={{ textOverflow: 'ellipsis', }} noWrap>
                {user?.crew?.nickname || 'crew'}
              </Typography>
              <Typography variant="caption" noWrap sx={{ color: 'text.secondary' }}>
                {application?.get_position_display} | {application?.years_of_experience ? `${application.years_of_experience}년차` : '연차 미설정'}
              </Typography>
            </Box>
          </AvatarStyle>

          {/* position & career */}
          <Stack spacing={1}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <SvgIconStyle src="/icons/ic_trophy.svg" sx={{ width: 16, height: 16, color: 'text.disabled' }} />
              {application?.main_role && (
                <Typography variant="caption">
                  {application?.main_role.role}
                </Typography>
              )}
              {!application?.main_role && (
                <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                  메인 포지션을 설정해주세요
                </Typography>
              )}
            </Stack>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <SvgIconStyle src="/icons/ic-job.svg" sx={{ width: 16, height: 16, color: 'text.disabled' }} />
              {application?.careers?.length > 0 && (
                <Typography variant="caption">
                  {sortedCareer[0].name}
                </Typography>
              )}
              {application?.careers?.length === 0 && (
                <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                  직장 이력을 설정해주세요
                </Typography>
              )}
            </Stack>
          </Stack>

          {/* profile button */}
          <Stack spacing={0.5}>
            <Divider />
            <Button
              onClick={goSetting}
              size="small"
              sx={{ color: "text.secondary" }}
              startIcon={<SvgIconStyle src="/icons/icon-setting-mono.svg" sx={{ width: 16, height: 16 }} />}
            >
              프로필 설정
            </Button>
          </Stack>
        </RootStyle>
      </Link>
    </NextLink>
  );
}
